export const STATUS_COLORS = {
  Light: "#009639",
  Moderate: "#e0a300",
  Heavy: "#da291c",
};

export const riskClass = (v) => (v || "").toLowerCase();

export const statusColor = (status) => STATUS_COLORS[status] || "#5b7186";
